<template>
  <div id="conTagConfig">
    <div class="p-4 border-radius-top-t">
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <div
        class="bg-primary d-flex justify-space-between py-4 px-5 border-radius-top-t"
      >
        <div class="d-flex align-center">
          <v-btn icon color="transparent" to="/calls">
            <v-icon color="white">mdi-arrow-left</v-icon>
          </v-btn>
          <h3 class="font-weight-bold text-complementary-color">
            Etiquetado de grabaciones
          </h3>
        </div>
        <v-btn @click="$emit('newTag', true)">
          <v-icon class="plus" color="#27e96a">mdi-plus-circle-outline</v-icon>
          Nueva etiqueta
        </v-btn>
      </div>
      <div class="d-flex flex-column pa-5 bg-complementary">
        <h3 class="text-subtitle-1 font-weight-bold my-5">
          Etiquetas configuradas
        </h3>
        <v-data-table
          :headers="headers"
          :items="tagList"
          :loading="loading"
          item-key="id"
          disable-sort
          class="elevation-1 border-primary-color"
        >
          <template v-slot:item.Tag="{ item }">
            <div>
              {{ item.Tag }}
            </div>
          </template>
          <template v-slot:item.Values="{ item }">
            <div class="d-flex flex-wrap">
              <div
                class="contValue"
                v-for="(value, index) in item.Values"
                :key="index + '-value-tag'"
              >
                <span class="text-body-2 font-weight-medium">{{ value }}</span>
              </div>
            </div>
          </template>
          <template v-slot:item.action="{ item }">
            <div class="d-flex justify-end">
              <div class="line"></div>
              <div class="contAction" @click="$emit('editTagComment', item)">
                <v-icon>mdi-pencil-outline</v-icon>
              </div>
              <div class="contAction" @click="deleteItem(item)">
                <v-icon>mdi-trash-can-outline</v-icon>
              </div>
            </div>
          </template>
        </v-data-table>
      </div>
      <Delete ref="confirm"></Delete>
      <v-snackbar
        v-model="showError"
        color="black"
        :timeout="5000"
        max-width="100"
      >
        {{ textError }}
      </v-snackbar>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Delete from "@/components/deleteConfirm.vue";
export default {
  components: {
    Delete,
  },
  data() {
    return {
      headers: [
        { text: "Clave", value: "Tag" },
        { text: "Valor", value: "Values" },
        { text: "", value: "action" },
      ],
      showError: false,
      textError: "",
      loading: false,
    };
  },
  mounted() {
    this.getDataTagComments();
  },
  computed: {
    ...mapState("tagConfigComments", ["tagList"]),
  },
  methods: {
    async getDataTagComments() {
      this.loading = true;
      try {
        await this.$store.dispatch("tagConfigComments/getTagComments");
      } catch (error) {
        this.$store.commit("tagConfigComments/SET_TAG_COMMENTS", []);
        this.textError = error;
        this.showError = true;
      }
      this.loading = false;
    },
    async deleteItem(item) {
      if (
        await this.$refs.confirm.open(
          "Eliminar",
          "Esta seguro que desea elminar la etiqueta de esta grabación?",
          { color: "black" }
        )
      ) {
        this.loading = true;
        const list = [...this.tagList];
        list.splice(list.indexOf(item), 1);
        try {
          this.$store.commit("tagConfigComments/SET_TAG_COMMENTS", list);
          await this.$store.dispatch(
            "tagConfigComments/updateTagComments",
            list
          );
        } catch (error) {
          this.textError = error;
          this.showError = true;
        }
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">
@import "../../styles/global.scss";

#conTagConfig {
  width: 100%;
  background: background-tertiary !important;
  .line {
    width: 1px;
    height: 33px;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    margin-right: 10px;
  }
  .contAction {
    width: fit-content;
    border: 1px solid #e1e8eb;
    border-radius: 4px;
    padding: 4px 9px;
    margin: 0 5px;
    cursor: pointer;
  }
  .contValue {
    border: 1px solid #e1e8eb;
    background: #ededed;
    width: fit-content;
    padding: 0 5px;
    border-radius: 13px;
    margin: 2px 5px;
  }
}
</style>
